import { inject, Injectable, signal } from '@angular/core';

import { EMPTY, catchError } from 'rxjs';

import { TellentHttpApiService } from '@core/tellent-http-legacy';

import { HELP_DROPDOWN_CONFIG } from './help-dropdown.config';

interface ProductUpdatesResponse {
  data: Array<{ publishedAt: string }>;
}

@Injectable()
export class HelpDropdownService {
  readonly #http = inject(TellentHttpApiService);
  readonly #config = inject(HELP_DROPDOWN_CONFIG);

  public readonly hasUnreadUpdates = signal(false);

  #latestPublishedAt: string | null = null;

  constructor() {
    this.#checkForUpdates();
  }

  public markAsSeen(): void {
    if (this.#latestPublishedAt) {
      window.localStorage.setItem(this.#storageKey, this.#latestPublishedAt);
      this.hasUnreadUpdates.set(false);
    }
  }

  get #storageKey(): string {
    return `HelpDropdown#${this.#config.userId}_lastSeenProductUpdate`;
  }

  #checkForUpdates(): void {
    this.#http
      .get<ProductUpdatesResponse>(
        '/product-updates',
        { page: '1', pageSize: '1' },
        { skipCompany: true },
      )
      .pipe(catchError(() => EMPTY))
      .subscribe(response => {
        const latest = response.data[0];
        if (!latest) return;

        this.#latestPublishedAt = latest.publishedAt;
        const lastSeen = window.localStorage.getItem(this.#storageKey);
        this.hasUnreadUpdates.set(latest.publishedAt !== lastSeen);
      });
  }
}
